<template>
    <modal
        :name="modalName"
        transition="pop-out"
        :width="width"
        height="auto"
        scrollable
        :id="modalName"
        :adaptive="true"
        :click-to-close="false"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2 class="text-dark">
                            <slot name="header">{{ title }}</slot>
                        </h2>
                    </div>
                    <div class="col-2 text-right">
                        <button
                            type="button"
                            class="close"
                            aria-label="Cerrar"
                            @click.prevent="cerrar()"
                        >&times;</button>
                    </div>
                </div>
            </div>
            <div class="card-body p-0">
                <slot name="body">
                    <iframe
                        v-if="pdfUrl"
                        :src="pdfUrl"
                        :title="title"
                        class="reglamento-iframe"
                    ></iframe>
                </slot>
            </div>
            <div class="card-footer text-right">
                <slot name="footer">
                    <Button
                        type="button"
                        :label="buttonLabel"
                        @click.prevent="cerrar()"
                    />
                </slot>
            </div>
        </div>
    </modal>
</template>

<script>
    import Button from '@/modules/ui/Button.vue';

    /**
     * Reusable modal for displaying regulations (or any document/content)
     * inside the Vue 2 app. Backed by vue-js-modal: each instance must
     * have a unique `modalName` because vue-js-modal looks up modals by
     * name. Override any part of the modal via the `header`, `body`, or
     * `footer` slots.
     *
     * NOTE: stays in Options API (not <script setup>) because the
     * <modal> tag is provided by the vue-js-modal plugin via global
     * registration, and Vue 2.7's <script setup> does not resolve that
     * global tag reliably. The same trade-off applies to the existing
     * VisibilidadReducida.vue and other modal wrappers in the project.
     */
    export default {
        name: 'ModalReglamento',
        components: {
            Button
        },
        props: {
            /**
             * Unique identifier for this modal instance. Required because
             * vue-js-modal looks up modals by name, and the same component
             * may be reused for several regulations at once.
             */
            modalName: {
                type: String,
                required: true,
                validator: value => /^[a-z0-9-]+$/i.test(value)
            },
            title: {
                type: String,
                default: ''
            },
            pdfUrl: {
                type: String,
                default: ''
            },
            buttonLabel: {
                type: String,
                default: 'Entendido'
            },
            width: {
                type: Number,
                default: 900
            }
        },
        methods: {
            cerrar() {
                this.$emit('cerrar');
                this.$modal.hide(this.modalName);
            }
        }
    }
</script>

<style scoped>
    .reglamento-iframe {
        width: 100%;
        height: 70vh;
        border: 0;
        display: block;
    }
</style>